module.exports = __webpack_public_path__ + "img/logo.76b8f0cf.png";